/**
 * Helpers para keying consistente de daysList por profile::dayKey
 * Garantiza que no se pisan datos entre perfiles
 */

export const getDogsFor = (daysList, profile, dayKey) => {
  const k = `${profile}::${dayKey}`;
  return daysList?.[k] ?? daysList?.[dayKey] ?? [];
};

export const setDogsFor = (setDaysList, profile, dayKey, dogs) => {
  const k = `${profile}::${dayKey}`;
  setDaysList(prev => ({
    ...(prev || {}),
    [k]: Array.isArray(dogs) ? dogs : []
  }));
};
